export const LOCAL_STORAGE_KEY = {
    token: "token",
    patientsCache: "patientsCache",
    usersCache: "usersCache",
};

export const PERMISSIONS = {
    superAdmin: "Super Admin",
    read: "Read",
    write: "Write",
    delete: "Delete",
};

export const STATUS = {
    active: "Active",
    inactive: "Inactive",
    pending: "Pending",
};

export const STATUS_LIST = [
    { text: "Active", value: "Active" },
    { text: "Inactive", value: "Inactive" },
];

export const MEMBER_LIST = [
    { text: "Member", value: "true" },
    { text: "Non-member", value: "false" },
];

export const SUBSCRIBED_LIST = [
    { text: "Subscribed", value: "true" },
    { text: "Unsubscribed", value: "false" },
];

export const PLATFORM_LIST = [
    { text: "Android", value: "Android" },
    { text: "iOS", value: "iOS" },
];

export const FIRST_DATA_LIST = [
    { text: "Yes", value: "Yes" },
    { text: "No", value: "No" },
];

export const HEALTH_TYPE = {
    BODY_MASS: "bodyMass",
    BMI: "bmi",
    LEAN_BODY_MASS: "leanBodyMass",
    BODY_FAT_PERCENTAGE: "bodyFatPercentage",
    HEIGHT: "height",
    STEP_COUNT: "stepCount",
    SLEEP_ANALYSIS: "sleepAnalysis",
};

export const HEALTH_LABEL = {
    bodyMass: "Weight",
    bmi: "BMI",
    leanBodyMass: "Lean Body Mass",
    bodyFatPercentage: "Body Fat %",
    height: "Height",
    stepCount: "Steps",
    sleepAnalysis: "Sleep Analysis",
};

export const HEALTH_UNIT = {
    bodyMass: "lbs",
    bmi: "",
    leanBodyMass: "lbs",
    bodyFatPercentage: "%",
    height: "ft in",
    stepCount: "",
    sleepAnalysis: "",
};

export const HEALTH_STARTING_TYPE = {
    startingWeight: "startingWeight",
    startingWeightDate: "startingWeightDate",
    startingBMI: "startingBMI",
    startingBodyFatPercentage: "startingBodyFatPercentage",
    startingLeanBodyMass: "startingLeanBodyMass",
    treatmentStartDate: "treatmentStartDate",
};
